/* ============================================
   e-Lumii Custom JavaScript
   Ajouter dans: assets/lumii-scripts.js
   Puis inclure dans layout/theme.liquid avant </body>:
   <script src="{{ 'lumii-scripts.js' | asset_url }}" defer></script>
   ============================================ */

(function() {
  'use strict';

  // === SCROLL ANIMATIONS (IntersectionObserver) ===
  function initScrollAnimations() {
    var elements = document.querySelectorAll('.lumii-fade-in, .lumii-fade-in-left, .lumii-fade-in-right');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      });

      elements.forEach(function(el) {
        observer.observe(el);
      });
    } else {
      // Fallback: show all
      elements.forEach(function(el) {
        el.classList.add('visible');
      });
    }
  }

  // === ANNOUNCEMENT BAR COUNTDOWN ===
  function initAnnouncementCountdown() {
    var el = document.getElementById('announcement-countdown');
    if (!el) return;

    var storageKey = 'lumii_announce_end';
    var endTime = localStorage.getItem(storageKey);
    var duration = 20 * 60; // 20 minutes

    if (!endTime || parseInt(endTime) < Date.now()) {
      endTime = Date.now() + duration * 1000;
      localStorage.setItem(storageKey, endTime);
    } else {
      endTime = parseInt(endTime);
    }

    function update() {
      var remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      el.textContent = String(m).padStart(2, '0') + ' : ' + String(s).padStart(2, '0');

      if (remaining <= 0) {
        endTime = Date.now() + duration * 1000;
        localStorage.setItem(storageKey, endTime);
      }
    }

    update();
    setInterval(update, 1000);
  }

  // === NEWSLETTER POPUP ===
  function initNewsletterPopup() {
    var popup = document.getElementById('lumii-newsletter-popup');
    if (!popup) return;

    // Check if already shown recently
    var lastShown = localStorage.getItem('lumii_popup_shown');
    if (lastShown && Date.now() - parseInt(lastShown) < 24 * 60 * 60 * 1000) return;

    // Show after 8 seconds
    setTimeout(function() {
      popup.classList.add('active');
      localStorage.setItem('lumii_popup_shown', Date.now());
    }, 8000);

    // Close button
    var closeBtn = popup.querySelector('.lumii-newsletter-popup__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        popup.classList.remove('active');
      });
    }

    // Close on "Non merci"
    var noThanks = popup.querySelector('[data-dismiss]');
    if (noThanks) {
      noThanks.addEventListener('click', function() {
        popup.classList.remove('active');
      });
    }

    // Close on backdrop click
    popup.addEventListener('click', function(e) {
      if (e.target === popup) {
        popup.classList.remove('active');
      }
    });
  }

  // === FAQ ACCORDION ===
  function initFAQ() {
    var questions = document.querySelectorAll('.lumii-faq__question');
    questions.forEach(function(q) {
      q.addEventListener('click', function() {
        var item = q.closest('.lumii-faq__item');
        var isActive = item.classList.contains('active');

        // Close all
        document.querySelectorAll('.lumii-faq__item').forEach(function(i) {
          i.classList.remove('active');
        });

        // Toggle current
        if (!isActive) {
          item.classList.add('active');
        }
      });
    });
  }

  // === STICKY CTA (Mobile) ===
  function initStickyCTA() {
    var stickyCta = document.querySelector('.lumii-sticky-cta');
    var hero = document.querySelector('.lumii-hero');
    if (!stickyCta || !hero) return;

    window.addEventListener('scroll', function() {
      var heroBottom = hero.getBoundingClientRect().bottom;
      if (heroBottom < 0) {
        stickyCta.style.display = 'block';
      } else {
        stickyCta.style.display = 'none';
      }
    }, { passive: true });
  }

  // === PRODUCT IMAGE HOVER ZOOM ===
  function initProductZoom() {
    var images = document.querySelectorAll('.product__media-item img');
    images.forEach(function(img) {
      img.addEventListener('mouseenter', function() {
        img.style.transform = 'scale(1.05)';
        img.style.transition = 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
      });
      img.addEventListener('mouseleave', function() {
        img.style.transform = 'scale(1)';
      });
    });
  }

  // === SMOOTH SCROLL ===
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var target = document.querySelector(link.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // === INIT ALL ===
  function init() {
    initScrollAnimations();
    initAnnouncementCountdown();
    initNewsletterPopup();
    initFAQ();
    initStickyCTA();
    initProductZoom();
    initSmoothScroll();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
